import { BackButtonText } from "./constants";
import { LENDER_REPORTING_DASHBOARD } from "constants/routes";

const compareStrings = (a, b) => {
  if (a === "Everyone") {
    return -1;
  }
  if (b === "Everyone") {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }

  return 0;
};

export const assigneeComparison = (a, b) => {
  const splitA = a.name.split(" ");
  const splitB = b.name.split(" ");
  const lastA = splitA[splitA.length - 1];
  const lastB = splitB[splitB.length - 1];

  return lastA === lastB ?
    compareStrings(splitA[0], splitB[0]) :
    compareStrings(lastA, lastB);
};

export const getAssetManagerInitials = name => {
  if (name !== null) {
    const names = name.split(" ");
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
      initials = initials + names[names.length - 1].substring(0, 1).toUpperCase();
    }

    return initials;
  }

  return null;
};

export const getLinkText = prevLocation => {
  switch (prevLocation) {
    case BackButtonText.LENDER_REPORTS.FROM:
      return BackButtonText.LENDER_REPORTS.TEXT;
    case BackButtonText.DASHBOARD.FROM:
      return BackButtonText.DASHBOARD.TEXT;
    case BackButtonText.SUBMITTED.FROM:
      return BackButtonText.SUBMITTED.TEXT;
    default:
      return BackButtonText.DASHBOARD.TEXT;
  }
};

export const pushToPage = (history, dealId, rgiId) => {
  const buttonText = getLinkText(history.location.state?.from);
  switch (buttonText) {
    case BackButtonText.LENDER_REPORTS.TEXT:
      return history.push(`/deal/${dealId}/lender-reports`);
    case BackButtonText.DASHBOARD.TEXT:
      return history.push(LENDER_REPORTING_DASHBOARD);
    case BackButtonText.SUBMITTED.TEXT:
      return history.push(`/lenderReportingDashboard/submitted/${rgiId}`);
    default:
      return history.push(LENDER_REPORTING_DASHBOARD);
  }
};

const frequencyMap = [{ key: "monthly", value: 1 }, { key: "bi-monthly", value: 2 }, { key: "quarterly", value: 3 }, { key: "semi-annually", value: 4 }, { key: "annually", value: 5 }];

export const compareFrequency = (a, b) => {
  const x = frequencyMap.find(item => item.key === a.frequency);
  const y = frequencyMap.find(item => item.key === b.frequency);
    if (!x || !y) {
      return 0;
    }
    if (x.value < y.value) {
      return -1;
    }
    if (x.value > y.value) {
      return 1;
    }
    return a.reportName > b.reportName;
};
